import { createContext } from "react"
const ApiContext = createContext(null)

export default ApiContext